import produce, {enableES5} from "immer";
import React, {createContext, useContext, useCallback, useState} from "react";
import createPersistedState from "use-persisted-state";
enableES5();
export const STORE_NAME = process.env.GATSBY_STORE_NAME || "gatsby/store";
const useStoreState = createPersistedState(STORE_NAME);
export const storeContext = createContext([null, () => {
}]);
export function StoreProvider({initialState, ...props}) {
  const Provider = storeContext.Provider;
  const [state, setState] = useStoreState(initialState);
  return /* @__PURE__ */ React.createElement(Provider, {
    ...props,
    value: [
      state == null ? initialState : state,
      useCallback((updater) => {
        setState((state2) => produce(state2 == null ? initialState : state2, updater));
      }, [])
    ]
  });
}
export function useStore() {
  return useContext(storeContext);
}
